import { State } from "./State";
var nextStoreId = 0;
var StatesGroup = /** @class */ (function () {
    function StatesGroup() {
        var _this = this;
        this.storeId = nextStoreId++;
        this.name = "store-" + this.storeId;
        this.members = null;
        this.autoInitMembers = true;
        if (this.autoInitMembers) {
            setTimeout(function () { return _this.initializeMembers(); }, 0);
        }
    }
    // enableLog(enable: boolean): this {
    //     this.initializeMembers();
    //     this.members!.forEach(m => m.logEnabled = enable);
    //     return this;
    // }
    StatesGroup.prototype.connectAll = function () {
        this.initializeMembers();
        this.members.forEach(function (m) { return m.connect(); });
        return this;
    };
    StatesGroup.prototype.disconnectAll = function () {
        this.initializeMembers();
        this.members.forEach(function (m) { return m.disconnect(); });
        return this;
    };
    StatesGroup.prototype.initializeMembers = function (path, obj) {
        if (path === void 0) { path = ""; }
        if (obj === void 0) { obj = this; }
        if (this.members !== null) {
            return;
        }
        this.members = [];
        for (var propertyName in obj) {
            if (obj.hasOwnProperty(propertyName)) {
                var member = obj[propertyName];
                if (member instanceof State) {
                    member.name = this.name + path + "." + propertyName;
                    this.members.push(member);
                }
                else if (typeof member === "object") {
                    this.initializeMembers(path + "." + propertyName, member);
                }
            }
        }
    };
    return StatesGroup;
}());
export { StatesGroup };
